import {
  COURSE_SUCCESS,
  COURSE_DETAIL_REQUEST,
  COURSE_DETAIL_SUCCESS,
} from "./actionTypes";
import { CommonState } from "./types";
import { CommonActions } from "./actions";
import { MenuList } from "./index";

const initialState: CommonState = {
  menu: MenuList.Home,
  courseList: null,
  courseDetail: null
}

export default function commonReducer(state = initialState, action: CommonActions): CommonState {

  switch (action.type) {
    case COURSE_SUCCESS:
      return { ...state, courseList: action.payload }
    case COURSE_DETAIL_REQUEST:
      return { ...state, courseDetail: null }
    case COURSE_DETAIL_SUCCESS:
      return { ...state, courseDetail: action.payload }
    default:
      return state
  }
}